"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgActivity = function SvgActivity(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M27 29.838l2.051-6.154A1 1 0 0130 23h4a1 1 0 010 2h-3.28l-2.771 8.316c-.304.912-1.594.912-1.898 0L21 18.162l-2.051 6.154A1 1 0 0118 25h-4a1 1 0 010-2h3.28l2.771-8.316c.304-.912 1.594-.912 1.898 0L27 29.838z",
    id: "activity_svg__a"
  }));
};

var _default = SvgActivity;
exports["default"] = _default;